import { ACTION_TYPES } from "lib/Constants";

const {
  LOAD_ADMIN_VENDOR_LIST_REQUEST,
  LOAD_ADMIN_VENDOR_LIST_SUCCESS,
  LOAD_ADMIN_VENDOR_LIST_ERROR,
  SAVE_VENDOR_FORM_REQUEST,
  SAVE_VENDOR_FORM_SUCCESS,
  SAVE_VENDOR_FORM_ERROR,

  // vendor companyType
  LOAD_COMPANY_TYPE_SUCCESS,
  LOAD_COMPANY_TYPE_ERROR,
  LOAD_COMPANY_TYPE_REQUEST,

  // category
  LOAD_CATEGORY_TYPE_REQUEST,
  LOAD_CATEGORY_TYPE_ERROR,
  LOAD_CATEGORY_TYPE_SUCCESS,

  // vendor detail
  VENDOR_DETAIL_QUERY,
  VENDOR_DETAIL_SUCCESS,
  VENDOR_DETAIL_ERROR,

  // vendor photos
  VENDOR_PHOTOS_QUERY,
  VENDOR_PHOTOS_SUCCESS,
  VENDOR_PHOTOS_ERROR,

  VENDOR_ASSOCIATE_COMMUNITIES_SUCCESS,
  VENDOR_ASSOCIATE_COMMUNITIES_QUERY,
  VENDOR_ASSOCIATE_COMMUNITIES_ERROR,

  VENDOR_CONTACT_QUERY,
  VENDOR_CONTACT_ERROR,
  VENDOR_CONTACT_SUCCESS,

  VENDOR_ASSOCIATE_ORGANIZATION_QUERY,
  VENDOR_ASSOCIATE_ORGANIZATION_SUCCESS,
  VENDOR_ASSOCIATE_ORGANIZATION_ERROR,
  CHANGE_ERROR,
} = ACTION_TYPES;

export default {
  LOAD_SUCCESS: LOAD_ADMIN_VENDOR_LIST_SUCCESS,
  LOAD_ERROR: LOAD_ADMIN_VENDOR_LIST_ERROR,
  LOAD_REQUEST: LOAD_ADMIN_VENDOR_LIST_REQUEST,

  SAVE_REQUEST: SAVE_VENDOR_FORM_REQUEST,
  SAVE_SUCCESS: SAVE_VENDOR_FORM_SUCCESS,
  CHANGE_ERROR: CHANGE_ERROR,

  LOAD_COMPANY_TYPE_SUCCESS: LOAD_COMPANY_TYPE_SUCCESS,
  LOAD_COMPANY_TYPE_ERROR: LOAD_COMPANY_TYPE_ERROR,
  LOAD_COMPANY_TYPE_REQUEST: LOAD_COMPANY_TYPE_REQUEST,

  LOAD_CATEGORY_TYPE_REQUEST: LOAD_CATEGORY_TYPE_REQUEST,
  LOAD_CATEGORY_TYPE_SUCCESS: LOAD_CATEGORY_TYPE_SUCCESS,
  LOAD_CATEGORY_TYPE_ERROR: LOAD_CATEGORY_TYPE_ERROR,

  VENDOR_DETAIL_QUERY: VENDOR_DETAIL_QUERY,
  VENDOR_DETAIL_SUCCESS: VENDOR_DETAIL_SUCCESS,
  VENDOR_DETAIL_ERROR: VENDOR_DETAIL_ERROR,

  VENDOR_PHOTOS_QUERY: VENDOR_PHOTOS_QUERY,
  VENDOR_PHOTOS_SUCCESS: VENDOR_PHOTOS_SUCCESS,
  VENDOR_PHOTOS_ERROR: VENDOR_PHOTOS_ERROR,

  VENDOR_ASSOCIATE_COMMUNITIES_SUCCESS: VENDOR_ASSOCIATE_COMMUNITIES_SUCCESS,
  VENDOR_ASSOCIATE_COMMUNITIES_QUERY: VENDOR_ASSOCIATE_COMMUNITIES_QUERY,
  VENDOR_ASSOCIATE_COMMUNITIES_ERROR: VENDOR_ASSOCIATE_COMMUNITIES_ERROR,

  VENDOR_CONTACT_QUERY: VENDOR_CONTACT_QUERY,
  VENDOR_CONTACT_ERROR: VENDOR_CONTACT_ERROR,
  VENDOR_CONTACT_SUCCESS: VENDOR_CONTACT_SUCCESS,

  VENDOR_ASSOCIATE_ORGANIZATION_QUERY: VENDOR_ASSOCIATE_ORGANIZATION_QUERY,
  VENDOR_ASSOCIATE_ORGANIZATION_SUCCESS: VENDOR_ASSOCIATE_ORGANIZATION_SUCCESS,
  VENDOR_ASSOCIATE_ORGANIZATION_ERROR: VENDOR_ASSOCIATE_ORGANIZATION_ERROR,
};
